// #region customizations — tools adapter for the CustomFieldCatalogService port
// (complete-custom-fields-capability, task 3.2, perf-fixed in a task 3.5 follow-up). Wired in
// `app/aurora.provider.ts` as `{ provide: CustomFieldCatalogService, useClass:
// CustomFieldCatalogToolsAdapter }`, mirroring `CurrentAccountIamAdapter` — but unlike that
// adapter, this class's OWN top-level imports must stay tiny: `aurora.provider.ts` is the
// application's EAGER entry (loaded at bootstrap, before any route), so whatever this file
// statically imports lands in the initial bundle. Two measured fixes were both required:
//   1. The actual tools GraphQL query + mapping logic — which needs `resolveI18nValue`,
//      `TranslocoService`, and the three custom-field data-access configs — lives in
//      `./custom-field-catalog.tools-query.ts` and is reached ONLY via the dynamic `import()`
//      below, never a static specifier (a plain static import added ~390 KB to the initial chunk).
//   2. `CustomFieldCatalogService` itself is imported through the file-level alias
//      `@aurora/components/custom-field-capture-form/custom-field-catalog.service`, NOT the
//      folder's `index.ts` barrel: that barrel also `export *`s the `CustomFieldCaptureForm`
//      Angular component (and transitively its Spartan combobox/date-picker/calendar deps) —
//      esbuild cannot tree-shake a co-exported component out of a barrel (its `ɵcmp` definition
//      is a non-pure call), so naming ONLY the service still pulled the component's ~150 KB in.
import { Injectable, Injector, inject } from '@angular/core';
// Type-only — fully erased before bundling, so pulling it from the folder's barrel costs nothing
// (unlike the runtime `CustomFieldCatalogService` class below, which must NOT go through it).
import type { CustomFieldCatalog } from '@aurora/components/custom-field-capture-form';
import { CustomFieldCatalogService } from '@aurora/components/custom-field-capture-form/custom-field-catalog.service';
import { from, switchMap, type Observable } from 'rxjs';

@Injectable()
export class CustomFieldCatalogToolsAdapter extends CustomFieldCatalogService {
  private readonly injector = inject(Injector);

  fetch(entityType: string): Observable<CustomFieldCatalog> {
    return from(import('./custom-field-catalog.tools-query')).pipe(
      switchMap(({ fetchCustomFieldCatalogFromTools }) =>
        fetchCustomFieldCatalogFromTools(entityType, this.injector),
      ),
    );
  }
}
// #endregion
